import tripUpdatesActionCreators, { actionTypes } from './tripUpdatesActions';

export default tripUpdatesActionCreators;
export { actionTypes };
